import React from 'react';

export const TELAS_HISTORICO = [
  { rotulo: 'Relatórios do Módulo de Relatório', caminho: '/isa/modulo-relatorio' },
  { rotulo: 'Solicitações on-demand', caminho: '/isa/solicitacao-ondemand' },
  { rotulo: 'Relatórios do MPDV', caminho: '/isa/download-relatorio' },
];

const TelasHistorico = () => (
  <ul className="download-page__telas">
    {TELAS_HISTORICO.map(({ rotulo, caminho }) => (
      <li key={caminho}>
        <a href={caminho}>{rotulo}</a>
      </li>
    ))}
  </ul>
);

export default TelasHistorico;
